import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unlock_file",
  "use": "icon-unlock_file-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-unlock_file\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10.5,13.85v1.5h3v-1.5ZM8.67,10.7h8.66a.66.66,0,0,1,.67.65v6.5a.66.66,0,0,1-.67.65H6.67A.66.66,0,0,1,6,17.85v-6.5a.66.66,0,0,1,.67-.65h.66v-.65a4.58,4.58,0,0,1,3.6-4.43A4.7,4.7,0,0,1,16.17,8L15,8.6a3.35,3.35,0,0,0-3.75-1.71,3.26,3.26,0,0,0-2.56,3.16Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol